import Invoices from "./Invoices";
export default function CreditNotes() {
    return <Invoices docType="credit_note" title="Credit Notes" kicker="SALES" subtitle="Adjustments, returns, and refunds against issued invoices." newPath="/sales/invoices/new" />;
}
